import axios from 'axios';

import { AMO_API_URL } from '@/utils/constants';

export const axiosInstance = axios.create({
  baseURL: AMO_API_URL,
  xsrfCookieName: '_csrf',
  xsrfHeaderName: 'X-CSRF-Token',
});

export const defaultRequestConfig = {
  errorRetryCount: 2,
  errorRetryInterval: 2000,
  checkIsRetryableError: (error) => {
    return error.response && error.response.status >= 400;
  },
};

export async function callApi(axiosParams, propsRequestConfig, payload = { retryCount: 1 }) {
  const requestConfig = { ...defaultRequestConfig, ...propsRequestConfig };

  return axiosInstance(axiosParams).catch((error) => {
    const isRetryUnneeded =
      typeof requestConfig.errorRetryCount === 'number' &&
      payload.retryCount > requestConfig.errorRetryCount;
    if (isRetryUnneeded) {
      throw error;
    }

    if (!requestConfig.checkIsRetryableError(error)) {
      throw error;
    }

    // exponential backoff
    const count = Math.min(payload.retryCount, 8);
    // eslint-disable-next-line no-bitwise
    const timeout = ~~((Math.random() + 0.5) * (1 << count)) * requestConfig.errorRetryInterval;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(callApi(axiosParams, requestConfig, { retryCount: payload.retryCount + 1 }));
      }, timeout);
    });
  });
}
